var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"play"},[(_vm.source)?_c('my-player',{attrs:{"sourceSrc":_vm.source}}):_vm._e(),(_vm.videoSrc)?_c('iframe',{attrs:{"src":_vm.videoSrc,"frameborder":"0"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }